"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMultiSelectActionToolbar = exports.StyledLabelContainer = exports.StyledLabel = exports.StyledH6 = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 1.2rem;\n  width: 5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.25em 0.5em;\n  border-radius: 3px;\n  font-size: 0.875rem;\n  line-height: 1.55rem;\n  white-space: nowrap;\n  background-color: #35ac46;\n  color: #ffffff;\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  width: auto;\n\n  [class|=\"StyledLabel\"] {\n    height: 1.2rem;\n    width: 5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 3rem;\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledMultiSelectActionToolbar = _styledComponents.default.div(_templateObject());
exports.StyledMultiSelectActionToolbar = StyledMultiSelectActionToolbar;
var StyledH6 = _styledComponents.default.h6(_templateObject2());
exports.StyledH6 = StyledH6;
var StyledLabelContainer = _styledComponents.default.div(_templateObject3());
exports.StyledLabelContainer = StyledLabelContainer;
var StyledLabel = _styledComponents.default.div(_templateObject4());
exports.StyledLabel = StyledLabel;